"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Heading = _interopRequireDefault(require("../Heading"));

var H3 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H3",
  componentId: "sc-1e9f2lb-0"
})([""]);
H3.propTypes = _Heading.default.propTypes;
H3.defaultProps = Object.assign({}, _Heading.default.defaultProps, {
  tagName: 'h3'
});
H3.displayName = 'H3';
var _default = H3;
exports.default = _default;
module.exports = exports.default;